/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Vs_DescInputs */

const en_fc_online_vs_desc = /** @type {(inputs: Fc_Online_Vs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The browser build is perfect for trying FilmCraft or quick edits. For long timelines and 4K footage, the native desktop app is faster.`)
};

/**
* | output |
* | --- |
* | "The browser build is perfect for trying FilmCraft or quick edits. For long timelines and 4K footage, the native desktop app is faster." |
*
* @param {Fc_Online_Vs_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_vs_desc = /** @type {((inputs?: Fc_Online_Vs_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Vs_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_vs_desc(inputs)
});
export { fc_online_vs_desc as "fc.online.vs.desc" }